import { Col, Input, Row } from 'antd';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'ui';
import { v4 as uuidv4 } from 'uuid';
import Table from '../../../../common/table/table';
import { Icons, RowIconAction } from '../../../../common/table/table-helper';
// eslint-disable-next-line max-len
import { updateOperations } from '../../../containers/smart-action-sidepanel/smart-action-sidepanel-actions';
import { IconWrapper, InfoRow, StyledInfoIcon, StyledRow } from './styles';
import { action, handleUpdate } from './tab-helpers';

const OperationsTableTab = ({
  intl,
  renderSaveButton,
  disabled,
}) => {
  const [operationValue, setOperationValue] = useState();
  const { operations } = useSelector(state => state.smartAction);
  const dispatch = useDispatch();

  const handleDispatch = (updatedOperations) => {
    dispatch(updateOperations(
      updatedOperations,
    ));
  };

  const getColumns = () => [
    {
      id: 'actions',
      displayName: '',
      fieldName: '',
      width: '16px',
      renderFn: r => <Icons>
        <RowIconAction
          title={intl.formatMessage({ id: 'order.tooltip.deleteOperation' })}
          tooltipKey='delete'
          iconKey='trash-alt'
          action={() => handleDispatch(
            handleUpdate({
              data: operations,
              actionType: action.singleDelete,
              id: r.id,
            }),
          )}
          disabled={disabled}
        />
      </Icons>,
    },
    {
      displayName: intl.formatMessage({ id: 'order.taskList.OPERATIONS' }),
      fieldName: 'operationDescription',
      id: 'operations',
      tooltip: row => row.operationDescription,
    },
  ];

  const handleOperationValueChange = (e) => {
    const { value } = e.target;
    if (value.length <= 40) {
      setOperationValue(value);
    }
  };

  const handleAddOperations = () => handleUpdate({
    data: operations,
    actionType: action.singleAdd,
    newItem: {
      id: uuidv4(),
      operationDescription: operationValue,
      addToOrder: true,
      index: operations?.length + 1,
    },
  });

  const renderFooter = () => <Row type='flex' gutter={16} >
    <Col span={18}>
      <Input
        placeholder={intl.formatMessage({
          id: 'order.taskList.ENTER_DESCRIPTION',
        })}
        value={operationValue}
        disabled={disabled}
        onChange={handleOperationValueChange}
        onPressEnter={
          () => {
            handleDispatch(handleAddOperations());
            setOperationValue('');
          }
        }
      />
    </Col>
    <Col span={6}>
      <Button
        onClick={
          () => {
            handleDispatch(handleAddOperations());
            setOperationValue('');
          }
        }
        disabled={disabled || !operationValue}
        type='secondary'
      >
        {intl.formatMessage({ id: 'order.taskList.ADD' }).toUpperCase()}
      </Button>
    </Col>
  </Row>;

  const handleDrop = (dragAndDroppedOperations) => {
    if (!disabled) {
      handleDispatch(dragAndDroppedOperations);
    }
  };

  return (
    <>
      {!disabled ? <InfoRow>
        <IconWrapper>
          <StyledInfoIcon type='info-square' size='lg' onClick={e => e.preventDefault()} />
          {intl.formatMessage({ id: 'ticket.smart_actions.ADD_OPERATION' })}
        </IconWrapper>
      </InfoRow> :
        null
      }
      <StyledRow>
        <Table
          movableRows={true}
          labelInColumn={true}
          columns={getColumns()}
          data={operations}
          onDrop={handleDrop}
          renderCustomFooter={renderFooter}
          disabled={disabled}
        />
      </StyledRow>
      {renderSaveButton()}
    </>
  );
};

OperationsTableTab.propTypes = {
  intl: PropTypes.object,
  renderSaveButton: PropTypes.func,
  disabled: PropTypes.bool,
};

export default injectIntl(OperationsTableTab);
